<template>
  <div id="app"
    class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav :selectedLanguage="selectedLanguage" page="blogs" :gotodownload="gotodownload" :apk="apk" />


    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <!-- 搜索 -->
<!--  -->
            <div class="all-blog-list">
              <div class="nav-tabs">
                <div class="blog-list-header selected-blog" @click="goGbSelectBlog('https://gbmodshub.com/news/')">
                  GBWhatsApp News & Tips
                </div>
                <div class="blog-list-header" @click="goGbSelectBlog('https://gbmodshub.com/news/tricks/')">
                  GB WhatsApp Tricks
                </div>
                <div class="blog-list-header" @click="goGbSelectBlog('https://gbmodshub.com/news/gbwhatsapp-update/')">
                  GBWhatsApp Update
                </div>
                <div class="blog-list-header" @click="goGbSelectBlog('https://gbmodshub.com/news/wa-mods/')">
                  WhatsApp Mods
                </div>
                <div class="blog-list-header" @click="goGbSelectBlog('https://gbmodshub.com/news/download-tips/')">
                  Download Tips
                </div>
              </div>
              <div>
                <div class="blog-list-row">
                  <a :href="data.url" v-for="(data, i) in doc.bloglist['all'].slice().reverse()" :key="i"
                    class="blog-list-item">
                    <div class="blog-list-img">
                      <img :src="data.poster" :alt="data.title">
                    </div>
                    <div class="blog-list-content">
                      <div class="blog-list-title">
                        {{ data.title }}
                      </div>
                      <div class="blog-list-descript">
                        {{ data.desc }}
                      </div>
                      <div class="blog-list-date">
                        {{ data.date }}
                      </div>
                    </div>
                  </a>
                </div>
                <!-- <div class="blog-list-row">
                  <a :href="data.url" v-for="(data, i) in doc.bloglist['shooting'].slice().reverse()" :key="i"
                    class="blog-list-item">
                    <div class="blog-list-img">
                      <img :src="data.poster" :alt="data.title">
                    </div>
                    <div class="blog-list-content">
                      <div class="blog-list-title">
                        {{ data.title }}
                      </div>
                      <div class="blog-list-descript">
                        {{ data.desc }}
                      </div>
                      <div class="blog-list-date">
                        {{ data.date }}
                      </div>
                    </div>
                  </a>
                </div>
                <div class="blog-list-row">
                  <a :href="data.url" v-for="(data, i) in doc.bloglist['mods'].slice().reverse()" :key="i"
                    class="blog-list-item">
                    <div class="blog-list-img">
                      <img :src="data.poster" :alt="data.title">
                    </div>
                    <div class="blog-list-content">
                      <div class="blog-list-title">
                        {{ data.title }}
                      </div>
                      <div class="blog-list-descript">
                        {{ data.desc }}
                      </div>
                      <div class="blog-list-date">
                        {{ data.date }}
                      </div>
                    </div>
                  </a>
                </div>
                <div class="blog-list-row">
                  <a :href="data.url" v-for="(data, i) in doc.bloglist['news'].slice().reverse()" :key="i"
                    class="blog-list-item">
                    <div class="blog-list-img">
                      <img :src="data.poster" :alt="data.title">
                    </div>
                    <div class="blog-list-content">
                      <div class="blog-list-title">
                        {{ data.title }}
                      </div>
                      <div class="blog-list-descript">
                        {{ data.desc }}
                      </div>
                      <div class="blog-list-date">
                        {{ data.date }}
                      </div>
                    </div>
                  </a>
                </div> -->
              </div>
            </div>
            
          </main>
        </div>
      </div>
    </div>

    <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
      Download GBWhatsapp APK
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import doc from '@/documents/blogs.js';
import HeadNav from '@/components/HeadNav.vue';
export default {
  name: 'Home',
  components: {
    HeadNav},
  data() {
    return {
      pageName: 'home',
      selectedLanguage: 'en',
      doc: doc,
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      SearchInput: null,
      tabPosition: 'left',
    };
  },
  mounted() {
    if (window.innerWidth < 768) {
      this.tabPosition = 'top';
    } else {
      this.tabPosition = 'left';
    }
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },

  methods: {
    goto(name) {
      // window.location.href = url;
      this.$router.push({
        name: `${name}`
      });
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    goGbSelectBlog(url){
      window.location.href = url;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    gotoHome(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

::v-deep .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 600;
}

::v-deep .el-tabs__item.is-active {
  color: #2c9aa1;
  background: #cef5ff;
}

.icon {
  width: 24px;
  height: 24px;
  color: #fff;
}

@media (max-width: 768px) {
  .search-box {
    flex-direction: column;
    gap: 30px;
    align-items: flex-start;
  }
}
</style>
